import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMemoCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { faLoader } from '@fortawesome/pro-light-svg-icons';
import styles from './index.module.scss';
import { Tooltip } from 'src/common';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface IProps {
  isFilledData: boolean;
  isInProgress: boolean;
  className?: string;
}

const TenderReportBadge: FC<IProps> = props => {
  const { isFilledData, className } = props;
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t(isFilledData ? 'DetailsPage.procurementProcessedData' : 'DetailsPage.procurementInProcessingData')}
      placement={'topLeft'}
    >
      <FontAwesomeIcon
        icon={isFilledData ? faMemoCircleCheck : faLoader}
        className={classNames(styles.reportIcon, className)}
      />
    </Tooltip>
  );
};

export default TenderReportBadge;
